import baseApi from "./baseApi";
import moment from "moment";

export default {
    async getPlantData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/harvestplan/plants");

        return result.data;
    },
    async getWeatherData(plantID, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/harvestplan/weather?${[
            `plantID=${plantID}`,
            `startDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `endDate=${moment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);

        return result.data;
    },
    async getPlantUnits(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/harvestplan/plantUnits?${[
            `plantID=${plantID}`            
        ].join("&")}`);

        return result.data;
    },
    async getSettings(plantID, planDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/harvestplan/settings?${[
            `plantID=${plantID}`,
            `planDate=${moment(planDate).format('YYYY-MM-DD')}`           
        ].join("&")}`);

        return result.data;
    },
    async getPickHistory(cropLocationID, productVarietyID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/harvestplan/pickHistory?${[
            `cropLocationID=${cropLocationID}`,
            `productVarietyID=${productVarietyID}`
        ].join("&")}`);

        return result.data;
    },
    async getHarvestPlan(plantID, planDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/harvestplan?${[
            `plantID=${plantID}`,            
            `planDate=${moment(planDate).format('YYYY-MM-DD')}`
        ].join("&")}`);

        return result.data;
    },
    async updateHarvestPlan(harvestplan) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/harvestplan", harvestplan);
        return result.data;
    },
    async sendPieceRateAgreements(plantID, planDate, teamIDs){
        console.log('api')
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/harvestplan/sendPieceRateAgreements", {"PlantID": plantID, "PlanDate": planDate, "TeamIDs": teamIDs});
        return result.data;
    }
}